package com.vizio.redwolf.utils

import kotlin.js.JsExport

@JsExport
interface ConsentV2Environment : Environment {
    val host: String
    val envPath: String
    val clientApiKey: String
    val apiVersion: String
}

@JsExport
abstract class BaseConsentV2Environment(override val apiVersion: String = "v2") : ConsentV2Environment

@JsExport
data class DevConsentV2Environment(
    override val host: String = "dev.consent.cs.vizio.com",
    override val envPath: String = "", //TODO("It should be v2 EPAM team says but it has not been implemented to have v2 yet")
    override val clientApiKey: String
) : BaseConsentV2Environment()

@JsExport
data class StageConsentV2Environment(
    override val host: String = "stage.consent.cs.vizio.com",
    override val envPath: String = "", //TODO("It should be v2 EPAM team says but it has not been implemented to have v2 yet")
    override val clientApiKey: String
) : BaseConsentV2Environment()

@JsExport
data class PreProdConsentV2Environment(
    override val host: String = "pre-prod.consent.cs.vizio.com",
    override val envPath: String = "", //TODO("It should be v2 EPAM team says but it has not been implemented to have v2 yet")
    override val clientApiKey: String
) : BaseConsentV2Environment()

@JsExport
data class ProdConsentV2Environment(
    override val host: String = "prod.consent.cs.vizio.com",
    override val envPath: String = "", //TODO("It should be v2 EPAM team says but it has not been implemented to have v2 yet")
    override val clientApiKey: String
) : BaseConsentV2Environment()

fun chooseConsentV2Environment(group: ConsentV2EnvironmentConfig): ConsentV2Environment {
    return when (group.environmentGroup) {
        EnvironmentGroup.PROD -> ProdConsentV2Environment(clientApiKey = group.apiKey)
        EnvironmentGroup.PREPROD -> PreProdConsentV2Environment(clientApiKey = group.apiKey)
        EnvironmentGroup.STAGE -> StageConsentV2Environment(clientApiKey = group.apiKey)
        EnvironmentGroup.DEV -> DevConsentV2Environment(clientApiKey = group.apiKey)
        EnvironmentGroup.TEST -> TODO("Test Environment for Consent not defined yet!")
    }
}

